<template>
    <div style="flex:1; overflow:hidden;" @touchmove.stop="() => { }" :style="{display : is_top_modal ? null : 'none'}">
        <div style="flex:1; display:flex; flex-direction:column; position:relative; overflow:hidden;">
            <div style="flex:1; overflow-y:scroll; overflow-x: hidden; padding:0px 28px; ">
                <div v-if="!isShowCloseBtn" style="height:20px;"></div>
                <div @click="() => { $GlobalStore.closeLastModal() }" style="display: flex; gap: 4px; align-items: center; margin-top: 24px;">
                    <div>
                        <img :src="require('@/assets/img/arrow_tick_active.png')" style="rotate: 180deg;" alt="">
                    </div>
                    <div style="font-weight: 500; font-size: 14px; color: var(--color-main);">뒤로가기</div>
                </div>
                <div style="color:#210F03; font-size:32px; font-weight:bold; text-align:center; line-height: 46px; margin-top: 24px;">축구하러 오신 회원님,<br>반가워요!</div>
                <div style="font-size:12px; font-weight:500; margin-top:20px; text-align:center;line-height:20px;">학생, 아마추어, 일반 축구 팬, 엘리트 선수<span style="font-weight: 400;">라면</span> 일반 회원,<br>선수 출신이거나 축구 코치<span style="font-weight: 400;">라면</span> 전문가 회원<span style="font-weight: 400;">을 선택하세요</span></div>
                <div :class="isClicked ? 'active' : 'un_active'" @touchstart="touchStart(MEMBER_TYPE.USER)" @touchend="touchEnd(MEMBER_TYPE.USER)" @click="selectRegistType(MEMBER_TYPE.USER)" style="display:grid; transition: all 0.3s; position: relative; place-items: center; text-align:center; width:100%; height:184px; border: 1px solid #D9D9D9;border-radius: 24px; margin-top:40px;">
                    <div :style="{ opacity: isClicked ? '0.7' : '0.5' }" style="position: absolute; width: 100%; height: 100%; z-index: 0;">
                        <div style="position: absolute; top: 52%; left: 50%; transform: translate(-50%, -50%);">
                            <img :class="isClicked ? 'body_active' : 'body_un_active'" :src="require('@/assets/member_type_select/user_body.png')" alt="">
                            <div style="transition: all 0.3s;" :class="isClicked ? 'arm_active' : 'arm_un_active'">
                                <img :src="require('@/assets/member_type_select/user_arm.png')" alt="">
                            </div>
                            <div style="transition: all 0.3s;" :class="isClicked ? 'arm_ball_active' : 'arm_ball_un_active'">
                                <img :src="require('@/assets/member_type_select/user_arm_ball.png')" alt="">
                            </div>
                        </div>
                    </div>
                    <div style="width: calc(100% - 40px); position: relative; z-index: 1;">
                        <div style="font-weight:700; font-size:20px;">일반 회원</div>
                        <div style=" width:100%; color:#210F03;font-weight:500; font-size:12px; margin-top:20px;background: #FFCDACB2; height: 48px; display:grid;padding: 10px; place-items: center;border-radius: 12px;">취미, 팬, 학생 등 일반 회원</div>
                    </div>
                </div>
                <div :class="isClickedCoach ? 'active_coach' : 'un_active_coach'" @click="selectRegistType(MEMBER_TYPE.COACH)" @touchstart="touchStart(MEMBER_TYPE.COACH)" @touchend="touchEnd(MEMBER_TYPE.COACH)" style="display:grid; place-items: center; text-align:center; position: relative; width:100%; transition: all 0.3s; height:184px; border: 1px solid #D9D9D9;border-radius: 24px; margin-top:30px;">
                    <div style="position: absolute; width: 100%; height: 100%; z-index: 0;">
                        <div :style="{ opacity: isClickedCoach ? '0.3' : '0.2' }" style="position:absolute; white-space: nowrap; left: 50%; transition: all 0.3s; top: 49%; height: 100%; width: 100%; transform: translate(-50%, -50%); opacity: 0.2;">
                            <img style="transition: all 0.3s;" :class="isClickedCoach ? 'step_img_ani_active7' : 'step_img_ani_unactive7'" :src="require(`@/assets/member_type_select/coach_body.png`)" alt="">
                            <img style="transition: all 0.3s;" :class="isClickedCoach ? 'step_sub2_img_ani_active7' : 'step_sub2_img_ani_unactive7'" :src="require(`@/assets/member_type_select/coach_leg2.png`)" alt="">
                            <img style="transition: all 0.3s;" :class="isClickedCoach ? 'step_sub3_img_ani_active7' : 'step_sub3_img_ani_unactive7'" :src="require(`@/assets/member_type_select/coach_arm3.png`)" alt="">
                            <img style="transition: all 0.3s;" :class="isClickedCoach ? 'step_sub4_img_ani_active7' : 'step_sub4_img_ani_unactive7'" :src="require(`@/assets/member_type_select/coach_arm4.png`)" alt="">
                            <img style="transition: all 0.3s;" :class="isClickedCoach ? 'step_sub5_img_ani_active7' : 'step_sub5_img_ani_unactive7'" :src="require(`@/assets/member_type_select/coach_leg.png`)" alt="">
                            <img style="transition: all 0.3s;" :class="isClickedCoach ? 'step_sub6_img_ani_active7' : 'step_sub6_img_ani_unactive7'" :src="require(`@/assets/member_type_select/coach_ball.png`)" alt="">
                        </div>
                    </div>
                    <div style="width: calc(100% - 40px); position: relative; z-index: 1;">
                        <div><img :src="require('@/assets/img/coach_star_yellow.png')" style="width:16px; height:16px; margin-bottom: 6px;"></div>
                        <div style="font-weight:700; font-size:20px;">축구 전문가 회원</div>
                        <div style=" width:100%; color:#210F03;font-weight:500; font-size:12px; margin-top:20px;background: #7DABFFB2; height: 48px; display:grid;padding: 10px; place-items: center;border-radius: 12px;">선수 출신, 축구 코치, 감독 등 축구 전문가 회원</div>
                    </div>
                </div>
                <div style="height:30px;"></div>
                <!-- <template v-if="isExistLoginBtn">
                    <div style="border-radius:12px; background-color:#F5F5F5; height:48px; display:grid; place-items: center; color:#210F03; font-weight:bold; font-size:14px;" @click="showLogin">로그인하기</div>
                    <div style="height:30px;"></div>
                </template> -->
            </div>
        </div>
    </div>
</template>

<script>
import { MEMBER_TYPE } from "../../Constants";

export default {
    name: "MemberTypeSelectNew",
    props: {
        // isExistLoginBtn: {
        //     type: Boolean,
        //     default: false,
        // },
        isShowCloseBtn: {
            type: Boolean,
            default: true,
        },
        isCloseTwice: {
            type: Boolean,
            default: false
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        selectRegistType: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            MEMBER_TYPE: MEMBER_TYPE,
            isClicked: false,
            isClickedCoach: false
        }
    },
    computed : {
        is_top_modal(){
            const modal_length = this.$store.state.modals.length;
            if(modal_length > 0){
                const last_modal = this.$store.state.modals[modal_length - 1];
                //이전 화면이 아이디 비밀번호 혹은 소셜 로그인 후에 회원유형 선택하는 화면으로 넘어왔다면.
                if(last_modal.view === 'SignupCommonFrame' && !this.$hasOwnProperty(last_modal, 'step') && this.$hasOwnProperty(last_modal, 'id')){
                    return true;
                }
            }

            return false;
        }
    },
    mounted() {
        // this.$GlobalStore.closeLastModal();
        // this.completeAction(MEMBER_TYPE.USER);
    },
    methods: {
        touchStart(type) {
            if (type === MEMBER_TYPE.COACH) {
                this.isClickedCoach = true
            } else if (type === MEMBER_TYPE.USER) {
                this.isClicked = true
            }
        },
        touchEnd(type) {
            if (type === MEMBER_TYPE.COACH) {
                this.isClickedCoach = false
            } else if (type === MEMBER_TYPE.USER) {
                this.isClicked = false
            }
        },
        showLogin() {
            this.$GlobalStore.addModal('Login', { transitionName: 'bottom' });
        },
        close() {
            if (this.isCloseTwice) {
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.closeLastModal();
            } else {
                this.$GlobalStore.closeLastModal();
            }
        }
    }
}
</script>

<style scoped>
.active {
    background-color: #EA660E;
}

.un_active {
    background-color: #FF8939;
}

.arm_un_active {
    position: absolute;
    top: 49px;
    right: 0px;
    transform: rotate(0);
    transition: all 0.3s;
}

.arm_active {
    position: absolute;
    top: 49px;
    right: 4px;
    transform: rotate(10deg);
    transition: all 0.3s;
}

.arm_ball_un_active {
    position: absolute;
    top: 48px;
    left: -4px;
    transform: rotate(0);
    transition: all 0.3s;
}

.arm_ball_active {
    position: absolute;
    top: 41px;
    left: -1px;
    transform: rotate(-30deg);
    transition: all 0.3s;
}

.body_active {
    scale: 1.05;
    transition: all 0.3s;
}

.body_un_active {
    scale: 1;
    transition: all 0.3s;
}

.step_img_ani_unactive7 {
    transform: translate(81px, 23px);
}

.step_img_ani_active7 {
    transform: translate(92px, 23px);
}

.step_sub_img_ani_unactive7 {
    transform: translate(254px, -13px);
    opacity: 0;
}

.step_sub_img_ani_active7 {
    transform: translate(254px, -13px);
    opacity: 1;
}

.step_sub2_img_ani_unactive7 {
    transform: translate(-4px, 70px) rotate(5deg);
}

.step_sub2_img_ani_active7 {
    transform: translate(9px, 73px) rotate(0deg);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive7 {
    transform: translate(-74px, -39px) rotate(-20deg);
}

.step_sub3_img_ani_active7 {
    transform: translate(-65px, -43px) rotate(0deg);
}

.step_sub4_img_ani_unactive7 {
    transform: translate(-30px, -52px) rotate(-20deg);
}

.step_sub4_img_ani_active7 {
    transform: translate(-14px, -46px) rotate(2deg);
}

.step_sub5_img_ani_unactive7 {
    transform: translate(-118px, 11px) rotate(14deg);
    position: relative;
    z-index: 10;
}

.step_sub5_img_ani_active7 {
    transform: translate(-83px, 9px) rotate(0deg);
    position: relative;
    z-index: 10;
}

.step_sub6_img_ani_unactive7 {
    transform: translate(-151px, -1px);
}

.step_sub6_img_ani_active7 {
    transform: translate(-72px, -11px);
}

.active_coach {
    background: #216FE5;
}

.un_active_coach {
    background: #4C89E5;
}
</style>